/* unplugin-vue-components disabled */import { render } from "./ExternalTenant.vue?vue&type=template&id=22ea1e27"
import script from "./ExternalTenant.vue?vue&type=script&lang=js"
export * from "./ExternalTenant.vue?vue&type=script&lang=js"

import exportComponent from "/myfunnl/isspadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__